/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsPortfolioBase {
    getFixupPrototypeFunction() { return AppSecopsPortfolioBase.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsPortfolioBase>): AppSecopsPortfolioBase {
        let obj = Object.assign(new AppSecopsPortfolioBase(), model);
        AppSecopsPortfolioBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsPortfolioBase>): AppSecopsPortfolioBase {
        if (!model) return null;
        return AppSecopsPortfolioBase.newInstance(<AppSecopsPortfolioBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsPortfolioBase) {
        if (!obj) return;

        models.AppSecopsPortfolioBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsPortfolioBase): boolean {
        Object.setPrototypeOf(obj, AppSecopsPortfolioBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.tags) {
            for (let val of this.tags) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    /**
     * Name of the portfolio
     */
    name: string;

    /**
     * Portfolio description
     */
    description: string;

    /**
     * Owners of portfolio
     */
    owner: Array<string>;

    /**
     * Tenant ID
     */
    tenant_id: string;

    tags: Array<models.KeyValuePair>;

}
